<div #content [class.overflow-content-hidden]="overflowHidden" [class]="contentClass" [style.--max-height]="_cutoffHeight">
  @if (overflowHidden) {
    <div [@fadeIn]="'in'">
      <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
    </div>
  }

  @if (!overflowHidden) {
    <div [@fadeIn]="'in'">
      <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
    </div>
  }
</div>
@if (showToggleBtn) {
  <button class="flex cursor-pointer items-center text-primary mt-3" (click)="toggleOverflowHidden()">
    {{ overflowHidden ? 'Toon meer' : 'Toon minder' }}
    <vwui-icon
      class="vwui-icon-sm ml-2"
      iconName="vwui-chevron-up"
      [@rotated]="overflowHidden ? '-180': '0'"
    ></vwui-icon>
  </button>
}


<ng-template #contentTpl><ng-content></ng-content></ng-template>
